var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.872,
    height: 12.888,
    viewBox: "0 0 12.872 12.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a7a7a7;stroke:#a7a7a7;stroke-linejoin:round;stroke-width:0.8px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-42.476,190.125q0-.426,0-.851c0-.271,0-.542,0-.813,0-.191.1-.3.258-.3s.269.114.269.307q0,1.241,0,2.482c0,.028,0,.057-.007.091a.567.567,0,0,1-.086.013h-2.492c-.131,0-.253-.042-.281-.178a.338.338,0,0,1,.052-.261.383.383,0,0,1,.257-.094c.478-.009.956,0,1.434,0h.182a5.081,5.081,0,0,0-.928-.927,5.358,5.358,0,0,0-3.9-1.137,5.469,5.469,0,0,0-4.829,4.252,5.476,5.476,0,0,0,3.423,6.384,5.475,5.475,0,0,0,7.291-3.931,9.622,9.622,0,0,0,.142-1.177c.021-.207.1-.31.266-.309s.262.115.261.327a6.039,6.039,0,0,1-4.731,5.833,6.03,6.03,0,0,1-7.133-4.394,6.029,6.029,0,0,1,4.5-7.383,5.874,5.874,0,0,1,5.961,2.016l.055.064Z",
    transform: "translate(53.637 -187.492)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset_icon.e6945a18f2a12c50515c7bb7f43755cf.svg";
export { ForwardRef as ReactComponent };